export const GENERAL_FIELD_STATE_MAP: Record<string, string> = {
  WORKDESCR: 'workDescription',
  WORKLOCATION: 'workLocation',
  UNIT: 'unit',
  BUILDING: 'building',
  FLOOR: 'floor',
  ROOM: 'room',
  OTHER: 'other',
  STDATE: 'startDate',
  ENDATE: 'endDate',
  STTIME: 'startTime',
  ENTIME: 'endTime',
  CONTROLLER: 'controller',
  HAZAREA: 'hazardousArea',
}

export const GENERAL_SECTION_CODE = 'GENERAL'
